import { Component } from '@angular/core';

@Component({
  selector: 'mifosx-task-management',
  templateUrl: './task-management.component.html',
  styleUrls: ['./task-management.component.scss']
})
export class TaskManagementComponent {
  constructor() {}
}
